import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const Ctx = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => setContent(r.data))
      .catch(() => setContent({}));
  }, []);
  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
};

export const useContent = () => useContext(Ctx);
